import bufferedRowService from "@baserow/modules/database/services/view/bufferedRows";

// PeninsulaCalendarView inherits the OSE GalleryView row contract.
export default (client) => bufferedRowService(client, "gallery");
